import { UAE } from "../../mock";

const OfferingRow = ({ offering, flipped }) => (
  <div className="grid md:grid-cols-12 gap-8 md:gap-14 items-center" data-reveal data-testid={`offering-${offering.title}`}>
    <div className={`md:col-span-7 overflow-hidden ${flipped ? "md:order-2" : ""}`}>
      <div className="overflow-hidden">
        <img
          src={offering.img}
          alt={offering.title}
          loading="lazy"
          className="w-full h-[320px] md:h-[520px] object-cover hover:scale-[1.03] transition-transform duration-[900ms] ease-out"
          style={{ filter: "grayscale(6%)" }}
        />
      </div>
    </div>
    <div className={`md:col-span-5 ${flipped ? "md:order-1" : ""}`}>
      <h3 className="font-display text-[24px] md:text-[28px] leading-[1.1] tracking-tight mb-6">{offering.title}</h3>
      <p className="text-[#5f5a50] text-[14px] md:text-[15px] leading-relaxed font-light">{offering.body}</p>
    </div>
  </div>
);

export const Offerings = () => (
  <section className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-36" data-testid="home-offerings">
    <div className="grid md:grid-cols-12 gap-8 mb-16 md:mb-24" data-reveal>
      <h2 className="md:col-span-12 font-display font-light text-[22px] md:text-[34px] leading-[1.1] tracking-tight md:whitespace-nowrap">
        A comprehensive studio, from first sketch to hand-over.
      </h2>
    </div>
    <div className="space-y-24 md:space-y-32">
      {UAE.offerings.map((o, i) => (
        <OfferingRow key={o.title} offering={o} flipped={i % 2 === 1} />
      ))}
    </div>
  </section>
);
